import tagTester from './_tagTester.js';

export default tagTester('Error');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isError.js
// module id = 295
// module chunks = 0 1